import { SVGProps } from 'react';

export const Good = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 104 104"
        {...props}
    >
        <path
            fill="#91D25E"
            d="M67.168 47.667a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Zm-30.333 0a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Z"
        />
        <path
            fill="#91D25E"
            d="M52.001 69.333c-6.413 0-11.916-3.51-14.95-8.666h-7.236C33.28 69.55 41.905 75.833 52 75.833c10.097 0 18.72-6.283 22.187-15.166H66.95c-3.033 5.156-8.536 8.666-14.95 8.666Zm-.043-60.666C28.038 8.667 8.668 28.08 8.668 52c0 23.92 19.37 43.333 43.29 43.333 23.963 0 43.377-19.413 43.377-43.333 0-23.92-19.414-43.333-43.377-43.333Zm.043 78c-19.153 0-34.666-15.514-34.666-34.667 0-19.153 15.513-34.667 34.666-34.667 19.154 0 34.667 15.514 34.667 34.667 0 19.153-15.513 34.667-34.667 34.667Z"
        />
    </svg>
);
